import { render, staticRenderFns } from "./promo_refer.vue?vue&type=template&id=deab80f0&scoped=true&"
import script from "./promo_refer.vue?vue&type=script&lang=js&"
export * from "./promo_refer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deab80f0",
  null
  
)

export default component.exports